import React from 'react';
import {withRouter, NavLink} from 'react-router-dom';

import './index.scss';

const BreadCrumbs = (props) =>{

    const {root = '', className = '', crumbs = []} = props;

    const printBreadCrumbs = () =>{
        const path = props.match.path.split('/').slice(1);

        let res = [];

        if (crumbs.length > 0){
            res.push((
                <a key={root.text} href={root.route}>
                    {root.text}
                </a>
            ));

            crumbs.forEach((item, index) =>{
                res.push((
                    <a testID={`breadcrumbs-link-${index}`} key={index} href={item.route}>
                        {item?.text?.split('_')?.join(' ')}
                    </a>
                ));
            });
        }
        else if (path.length > 0){
            res.push((
                <NavLink testID={`breadcrumbs-navlink`} key={root.text} to={root.route}>
                    {root.text}
                </NavLink>
            ));

            path.forEach((item, index) => {
               res.push((
                   <a testID={`breadcrumbs-link-${index}`} key={index}>
                       {item?.split('_')?.join(' ')}
                   </a>
               ));
            });
        }

        return res;
    };

    return(
        <div testID={`breadcrumbs-root`} className={`bread-crumbs ${className}`}>
            {printBreadCrumbs()}
        </div>
    )
};

export default withRouter(BreadCrumbs);
